import { InfoError2 } from "@assets";
import { Row } from "@components/Flex";
import { Body } from "@components/Typography";
import { useStyles } from "./styles";
import { ErrorDisclaimerProps } from "./types";

export const ErrorDisclaimer = ({ message, style }: ErrorDisclaimerProps) => {
  const styles = useStyles();

  return (
    <div style={{ ...styles.container, ...style }}>
      <Row style={styles.row}>
        <InfoError2 size={20} style={styles.icon} />
        <Body style={styles.text}>{message}</Body>
      </Row>
    </div>
  );
};
